export type FixtureType = 
  | 'rectangle' 
  | 'circle' 
  | 'wall' 
  | 'bar' 
  | 'counter' 
  | 'stairs' 
  | 'door' 
  | 'plant';

export interface FloorPlanFixture {
  id: string;
  establishmentId: string;
  zoneId: string | null;
  name: string | null;
  type: FixtureType;
  x: number;
  y: number;
  width: number;
  height: number;
  color: string;
  rotation: number;
  createdAt: string;
  updatedAt: string;
}

export interface FixtureTypeConfig {
  type: FixtureType;
  label: string;
  icon: string;
  defaultColor: string;
  description: string;
}

export const FIXTURE_TYPES: FixtureTypeConfig[] = [
  { type: 'rectangle', label: 'Rectangle', icon: 'Square', defaultColor: '#6b7280', description: 'Forme rectangulaire générique' },
  { type: 'wall', label: 'Mur', icon: 'Minus', defaultColor: '#374151', description: 'Mur ou cloison' },
  { type: 'bar', label: 'Bar', icon: 'Wine', defaultColor: '#92400e', description: 'Comptoir de bar' },
  { type: 'counter', label: 'Comptoir', icon: 'Store', defaultColor: '#78716c', description: 'Comptoir d\'accueil' },
  { type: 'stairs', label: 'Escalier', icon: 'ArrowUpDown', defaultColor: '#64748b', description: 'Escalier' },
  { type: 'door', label: 'Porte', icon: 'DoorOpen', defaultColor: '#a16207', description: 'Porte ou entrée' },
  { type: 'plant', label: 'Plante', icon: 'TreeDeciduous', defaultColor: '#15803d', description: 'Plante décorative' },
  { type: 'circle', label: 'Cercle', icon: 'Circle', defaultColor: '#6b7280', description: 'Colonne ou élément rond' },
];
